import axios from "axios";

const configuredBaseUrl = (process.env.REACT_APP_API_URL || "").trim();

function inferApiBaseUrl() {
  if (typeof window === "undefined") {
    return "http://localhost:8000";
  }

  const { protocol, hostname, origin } = window.location;

  if (window.location.port === '8765' && (hostname === 'localhost' || hostname === '127.0.0.1')) {
    return origin;
  }

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return `${protocol}//${hostname}:8000`;
  }

  return `${origin}/api`;
}

const baseURL = (configuredBaseUrl || inferApiBaseUrl()).replace(/\/+$/, "");

const api = axios.create({ baseURL });

let onUnauthorizedHandler = null;

api.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 402 && typeof window !== 'undefined' && (process.env.REACT_APP_DISTRIBUTION === 'true' || window.location.port === '8765')) {
      window.location.assign('/license');
    }
    const currentToken = typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;
    const requestToken = error?.config?.headers?.Authorization;
    const staleSession = requestToken && currentToken && requestToken !== `Bearer ${currentToken}`;
    if (error?.response?.status === 401 && !staleSession && error?.config?.url !== '/auth/logout' && typeof onUnauthorizedHandler === 'function') {
      onUnauthorizedHandler(error);
    }

    return Promise.reject(error);
  }
);

export function getAssetUrl(path) {
  if (!path) {
    return null;
  }

  const rawPath = String(path).trim().replace(/\\/g, '/');
  if (!rawPath) {
    return null;
  }

  if (/^https?:\/\//i.test(rawPath)) {
    return rawPath;
  }

  let normalizedPath = rawPath;
  const staticIndex = normalizedPath.indexOf('/static/');
  if (staticIndex >= 0) {
    normalizedPath = normalizedPath.slice(staticIndex);
  } else if (normalizedPath.startsWith('static/')) {
    normalizedPath = `/${normalizedPath}`;
  } else if (!normalizedPath.startsWith('/')) {
    normalizedPath = `/${normalizedPath}`;
  }

  if (normalizedPath.startsWith('/static/')) {
    return `${baseURL}${normalizedPath}`;
  }

  return `${baseURL}${normalizedPath}`;
}

export function getApiErrorMessage(error, fallbackMessage = 'Erro ao processar a solicitação.') {
  const detail = error?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (detail?.message) {
    return detail.message;
  }

  if (detail?.error) return detail.error;
  if (Array.isArray(detail)) return detail.map((item) => item.msg).filter(Boolean).join(' · ') || fallbackMessage;
  if (!error?.response) return 'Não foi possível conectar ao servidor. Verifique a conexão e tente novamente.';

  return fallbackMessage;
}

export function setUnauthorizedHandler(handler) {
  onUnauthorizedHandler = handler;
}

export default api;
